import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { MessageCircleQuestion } from 'lucide-react';

const FAQPage = () => {
  const faqs = [
    {
      question: "Do you supply products outside of the UAE?",
      answer: "Yes, we handle export inquiries and ship to various GCC and African countries. Please contact our sales team with your exact requirements for shipping estimates."
    },
    {
      question: "How can I open a B2B corporate account?",
      answer: "To open a corporate account, please register on our website as a Business user and provide your Trade License. Once verified, our team will activate your B2B pricing and credit terms if applicable."
    },
    {
      question: "What is your return policy?",
      answer: "We accept returns for unused, standard stock items within 14 days of delivery. Custom orders or specially procured materials cannot be returned unless defective."
    },
    {
      question: "Can I request a quotation for a large BOQ?",
      answer: "Absolutely. You can upload your Bill of Quantities (BOQ) via our contact form or email it to sales@gpgt.ae. Our estimators will provide a comprehensive quotation within 48 hours."
    },
    {
      question: "Are your products certified for UAE standards?",
      answer: "Yes, all our electrical, plumbing, and safety products comply with UAE regulations, including ESMA and Civil Defense certifications where applicable."
    },
    {
      question: "Do you offer installation services?",
      answer: "We are primarily a trading and supply company. However, for certain specialized systems, we can recommend certified third-party contractors."
    }
  ];

  return (
    <div className="min-h-screen bg-background pb-20">
      {/* Header Banner */}
      <div className="bg-[#0c1b44] text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <MessageCircleQuestion className="h-12 w-12 mx-auto mb-4 text-gold opacity-80" />
          <h1 className="text-4xl font-bold mb-4">Frequently Asked Questions</h1>
          <p className="text-gray-300 max-w-2xl mx-auto text-lg">
            Find answers to common questions about our products, services, and corporate accounts.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16 max-w-3xl">
        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`} className="bg-white border border-gray-200 rounded-lg px-6 shadow-sm data-[state=open]:border-[#0c1b44] transition-colors">
              <AccordionTrigger className="text-left font-bold text-navy hover:no-underline py-4">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed pb-4 pt-2">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 text-center bg-gray-50 p-8 rounded-xl border border-gray-100">
          <h3 className="font-bold text-navy mb-2">Still have questions?</h3>
          <p className="text-gray-500 mb-4">Can't find the answer you're looking for? Please chat with our friendly team.</p>
          <a href="/contact" className="inline-block bg-[#0c1b44] text-white px-6 py-2 rounded-lg font-semibold hover:bg-[#1a2d64] transition-colors">
            Get in Touch
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
